import { render } from "./VideoGalleryPage.vue?vue&type=template&id=0334c64f"
import script from "./VideoGalleryPage.vue?vue&type=script&lang=js"
export * from "./VideoGalleryPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__